import { AutogenModelClassifications, AutogenRowClassifications } from "./autogen/AutogenModelClassifications";

export class ModelClassifications extends AutogenModelClassifications<RowClassifications> {
    constructor() {
        super(RowClassifications);
    }
}

export class RowClassifications extends AutogenRowClassifications {
}